import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BASE_URL } from '@models/global-constant.model';
import { helpApiUrlModuleSegment } from '../constants/help-module.constants';
import { HelpApiEnvelope, HelpPageTarget, HelpWalkthrough } from '../models/help-api.types';
import { helpNormalizeHttpError, helpUnwrapResponse } from './help-api.http.util';

@Injectable({
  providedIn: 'root',
})
export class HelpLeadsPublicApiService {
  constructor(private readonly http: HttpClient) {}

  private moduleBase(moduleKey: string): string {
    const seg = helpApiUrlModuleSegment(moduleKey);
    return `${BASE_URL}/help/${encodeURIComponent(seg)}`;
  }

  getTargets(moduleKey: string): Observable<HelpPageTarget[]> {
    return this.http.get<HelpApiEnvelope<HelpPageTarget[]>>(`${this.moduleBase(moduleKey)}/targets`).pipe(
      map(res => helpUnwrapResponse(res)),
      catchError(err => throwError(() => helpNormalizeHttpError(err)))
    );
  }

  getPublishedWalkthroughs(moduleKey: string): Observable<HelpWalkthrough[]> {
    return this.http.get<HelpApiEnvelope<HelpWalkthrough[]>>(`${this.moduleBase(moduleKey)}/walkthroughs`).pipe(
      map(res => helpUnwrapResponse(res)),
      catchError(err => throwError(() => helpNormalizeHttpError(err)))
    );
  }
}
